import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Dialog, FlatButton } from 'material-ui';
import { updateSuppProfileProps, importLocData } from '../../../stores/profile/company/profile-actions';
import { importProdData } from '../../../stores/profile/location/location-actions';
import ImportLoc from './importLocData';
import ImportProd from './importProdData';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const ImportData = props => {
  const {
    locOrProd,
    updateProp,
    profileReducer,
    prodType,
    importLocationData,
    importProductData,
    params,
  } = props;

  const updateTextForAccom = prodType === 'Accommodation' && locOrProd === 'location' ? 'Property' : locOrProd;

  return (
    <Dialog
      contentStyle={{ maxWidth: 'none', width: '75%' }}
      open={R.propOr(false, 'importDataOpen', profileReducer)}
      title={`Import Data From Another ${updateTextForAccom}`}
      actions={[
        <FlatButton
          label="Cancel"
          primary
          onTouchTap={() => updateProp({ itemToImport: {}, importDataOpen: false })}
        />,
        <FlatButton
          label="Import"
          secondary
          onTouchTap={() => {
            if (locOrProd === 'product') {
              importProductData({
                prodIdToImportTo: profileReducer.idToImportTo,
                locId: params.locationId,
                dataToImport: R.propOr({}, 'itemToImport', profileReducer),
                prodType,
              });
            } else {
              importLocationData({
                locIdToImportTo: profileReducer.idToImportTo,
                propertyName: R.pluck('name')(R.propOr([], 'locations', profileReducer).filter(loc => loc.id === profileReducer.idToImportTo))[0],
                dataToImport: R.propOr({}, 'itemToImport', profileReducer),
              });
            }
            updateProp({ itemToImport: {}, importDataOpen: false });
          }}
          disabled={isNilOrEmpty(R.propOr({}, 'itemToImport', profileReducer))}
        />,
      ]}
    >
      <div style={{ overflowY: 'scroll', height: '350px' }}>
        <div style={{ margin: '10px 0 30px 0' }}>
          Select which {updateTextForAccom} you want to import data from.
          <br/><br/>
          <span style={{ color: 'red', fontWeight: 600 }}>Warning: This will overwrite any existing data.</span>
        </div>
        {locOrProd === 'product' ?
          <ImportProd /> : <ImportLoc />}
      </div>
    </Dialog>
  );
};

ImportData.propTypes = {
  locOrProd: PropTypes.string,
  updateProp: PropTypes.func,
  profileReducer: PropTypes.object,
  prodType: PropTypes.string,
  importLocationData: PropTypes.func,
  importProductData: PropTypes.func,
  params: PropTypes.object,
};

const mapStateToProps = ({ profile, user }) => ({
  profileReducer: profile.toJS(),
  prodType: user.getIn(['company', 'productType']),
});

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateSuppProfileProps(...args)),
  importLocationData: (...args) => dispatch(importLocData(...args)),
  importProductData: (...args) => dispatch(importProdData(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportData);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/importData.jsx